(function () {
  'use strict';

  var EAGER_SELECTORS = [
    '.rabitat-hero-slider__slide.is-active img',
    '.rabitat-header__logo img',
    '.rabitat-mobile-menu__logo img',
    'img[loading="eager"]',
    'img[fetchpriority="high"]',
  ];

  var SCROLL_ROOT_SELECTORS = [
    '[data-collection-viewport]',
    '.rabitat-video-gallery__viewport',
    '[data-product-thumbs]',
    '[data-product-hero-viewport]',
    '.rabitat-collection__viewport',
    '.rabitat-responsive-images__viewport',
  ];

  var isSafari =
    typeof navigator !== 'undefined' &&
    /Safari/i.test(navigator.userAgent) &&
    !/Chrome|CriOS|Chromium|Edg|OPR|Android/i.test(navigator.userAgent);

  function isHeroProductImage(img) {
    var track = img.closest('[data-product-hero-track]');
    if (!track) return false;

    var firstImage = track.querySelector(
      '.rabitat-product-page__hero-image:not(.rabitat-product-page__hero-image--placeholder), [data-product-hero-slide]:first-child img'
    );

    return firstImage === img;
  }

  function isProductGalleryImage(img) {
    if (!img || img.tagName !== 'IMG') return false;

    return !!(
      img.closest('[data-product-thumbs]') ||
      img.closest('[data-product-hero-track]') ||
      img.closest('.rabitat-product-page__swatches')
    );
  }

  function shouldLoadEager(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.loading === 'eager' || img.getAttribute('fetchpriority') === 'high') return true;
    if (isHeroProductImage(img)) return true;

    for (var i = 0; i < EAGER_SELECTORS.length; i++) {
      try {
        if (img.matches(EAGER_SELECTORS[i])) return true;
      } catch (error) {
        /* ignore invalid selectors in older browsers */
      }
    }

    return false;
  }

  function getScrollRoot(img) {
    for (var i = 0; i < SCROLL_ROOT_SELECTORS.length; i++) {
      var root = img.closest(SCROLL_ROOT_SELECTORS[i]);
      if (root) return root;
    }

    var node = img.parentElement;
    while (node && node !== document.body) {
      var style = window.getComputedStyle(node);
      var overflowX = style.overflowX;
      var overflowY = style.overflowY;
      if (
        (overflowX === 'auto' || overflowX === 'scroll' || overflowY === 'auto' || overflowY === 'scroll') &&
        (node.scrollWidth > node.clientWidth || node.scrollHeight > node.clientHeight)
      ) {
        return node;
      }
      node = node.parentElement;
    }

    return null;
  }

  function setDecoding(img) {
    if (img.hasAttribute('decoding')) return;
    img.decoding = isSafari ? 'auto' : 'async';
  }

  function promoteImageLoad(img) {
    if (!img || img.tagName !== 'IMG') return;

    img.loading = 'eager';
    setDecoding(img);

    if (img.complete && img.naturalWidth > 0) return;

    if (isProductGalleryImage(img)) {
      if (typeof img.decode === 'function') {
        img.decode().catch(function () {});
      }
      return;
    }

    if (img.dataset.rabitatLoadRetry === 'true') return;

    window.requestAnimationFrame(function () {
      if (img.complete && img.naturalWidth > 0) return;

      window.setTimeout(function () {
        if (img.complete && img.naturalWidth > 0) return;
        if (img.dataset.rabitatLoadRetry === 'true') return;

        img.dataset.rabitatLoadRetry = 'true';
        var src = img.currentSrc || img.src;
        var srcset = img.srcset;

        if (!src && !srcset) return;

        if (srcset) {
          img.srcset = srcset;
        }

        if (src) {
          img.src = src;
        }
      }, isSafari ? 120 : 250);
    });
  }

  function observeLazyImage(img, observerRoots) {
    if (!('IntersectionObserver' in window)) return;
    if (img.dataset.rabitatLazyObserved === 'true') return;

    img.dataset.rabitatLazyObserved = 'true';

    var scrollRoot = getScrollRoot(img);
    var observerKey = scrollRoot ? 'scroll:' + scrollRoot.className : 'viewport';
    var observer = observerRoots[observerKey];

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            promoteImageLoad(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          root: scrollRoot || null,
          rootMargin: isSafari ? '320px 320px' : '200px 200px',
          threshold: 0.01,
        }
      );
      observerRoots[observerKey] = observer;
    }

    observer.observe(img);
  }

  function applyLazyLoading(root) {
    var images = [];

    if (root && root.nodeType === 1 && root.tagName === 'IMG') {
      images = [root];
    } else if (root && typeof root.querySelectorAll === 'function') {
      images = Array.prototype.slice.call(root.querySelectorAll('img'));
    } else {
      images = Array.prototype.slice.call(document.querySelectorAll('img'));
    }

    var observerRoots = {};

    images.forEach(function (img) {
      if (shouldLoadEager(img)) {
        img.loading = 'eager';
        setDecoding(img);
        return;
      }

      if (!img.hasAttribute('loading')) {
        img.loading = 'lazy';
      }

      setDecoding(img);

      if (isSafari || getScrollRoot(img)) {
        observeLazyImage(img, observerRoots);
      }
    });
  }

  function init() {
    applyLazyLoading(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    applyLazyLoading(event.target);
  });
})();
